import { gql } from "@apollo/client";
import {
  PaginatedListMetaNoNestingFragment,
  StockOrderItemNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";

const StockOrderFragment = `
${StockOrderItemNoNestingFragment}
fragment CustomStockOrderFragment on StockOrder {
    id
    locationId
    location {
        name
    }
    orderNumber
    formattedOrderNumber
    totalQuantity
    orderCreatedDate
    completedAt
    status
    items {
        ...StockOrderItemNoNesting
        product {
            name
            stockNumber
            image {
              path
            } 
            supplierId
            supplierStockCode
        }
    }
    createdAt
    updatedAt
    deletedAt
}
`;

export const QUERY_STOCK_ORDER = gql`
  ${StockOrderFragment}
  query stockOrder($id: ID!) {
    stockOrder(id: $id) {
      ...CustomStockOrderFragment
    }
  }
`;

export const QUERY_COUNT_STOCK_ORDERS = gql`
  query stockOrdersCount($options: StockOrderListOptions) {
    stockOrdersCount(options: $options)
  }
`;

export const QUERY_STOCK_ORDERS = gql`
  ${PaginatedListMetaNoNestingFragment}
  ${StockOrderFragment}
  query StockOrders($options: StockOrderListOptions) {
    stockOrders(options: $options) {
      items {
        ...CustomStockOrderFragment
      }
      meta {
        ...PaginatedListMetaNoNesting
      }
    }
  }
`;

export const MUTATION_DELETE_STOCK_ORDER = gql`
  mutation deleteStockOrder($id: ID!) {
    deleteStockOrder(id: $id) {
      reason
      result
    }
  }
`;

export const MUTATION_UPDATE_STOCK_ORDER_LINE_ITEMS = gql`
  ${StockOrderFragment}
  ${StockOrderItemNoNestingFragment}
  mutation updateStockOrderLineItems(
    $id: ID!
    $itemsToUpdate: [UpdateStockOrderLineItemInput!]
    $itemsToCreate: [CreateStockOrderLineItemInput!]
    $itemsToRemove: [ID!]
  ) {
    updateStockOrderLineItems(
      stockOrderId: $id
      itemsToUpdate: $itemsToUpdate
      itemsToCreate: $itemsToCreate
      itemsToRemove: $itemsToRemove
    ) {
      ...CustomStockOrderFragment
    }
  }
`;
export const MUTATION_CREATE_STOCK_ORDER = gql`
  ${StockOrderFragment}
  mutation createStockOrder($input: CreateStockOrderInput!) {
    createStockOrder(input: $input) {
      ...CustomStockOrderFragment
    }
  }
`;

export const MUTATION_CANCEL_STOCK_ORDER = gql`
  ${StockOrderFragment}
  mutation cancelStockOrder($id: ID!) {
    cancelStockOrder(id: $id) {
      ...CustomStockOrderFragment
    }
  }
`;

export const MUTATION_COMPLETE_STOCK_ORDER = gql`
  ${StockOrderFragment}
  mutation completeStockOrder($id: ID!) {
    completeStockOrder(id: $id) {
      ...CustomStockOrderFragment
    }
  }
`;

export const SEND_STOCK_ORDER_INBOUND_RETAILER = gql`
  mutation sendStockOrderInboundRetailer($id: ID!) {
    sendStockOrderInboundRetailer(id: $id) {
      success
    }
  }
`;
